import {
  SET_ME,
  SET_CONTACT,
  SET_ONLINE_STATUS,
  ADD_MSGS,
  DEL_MSGS,
  UPDATE_MSG,
  RESET_MSGS,
  SET_HAVE_MORE_MSG,
  SET_IS_SHOW_CAPTCHA,
  SET_CAPTCHA_TEMP_MSG_ID,
  SET_TOPIC,
  SET_IS_SHOW_EDITOR,
  UPDATE_NOW_VIDEO,
  UPDATE_WOS_FILENAME,
  DEL_MSG_TOAST,
  CARD_AJAX_TOAST,
  ADD_NOTICE_MSGS,
  // UPDATE_NOTICE_MSG
} from './../mutation-types';
import sdk from './../../global/sdk';
import SupportedMsgs from './../../global/SupportedMsgs';
import MsgStatus from './../../global/msgStatus';
import fileHandler from './../../components/common/upload/filehandler';
import config from './../../global/config';
import { isNeedConvert, richTextFormat } from '../../global/richTextFormat';
import html2Text from './../../global/html2Text';
import util from './../../utils/util';
import utils from '@/global/utils';
import tool from './../../utils/tool';
import falseNewsDic from './../../global/falseNewsDic';
import extend from './../../utils/extend';
let jsonHandler = utils.jsonHandler;
let isShopModeUser = utils.isShopModeUser;
let isShopModeUserSource = utils.isShopModeUserSource;
let isAnonymousSession = utils.isAnonymousSession;
let strToNumCompare = util.strToNumCompare;
let isEmpty = util.isEmpty;
let sumBigNumber = util.sumBigNumber;
const isGroupUser = tool.isGroupUser;
// 临时提醒消息
let temp_last_notice_id = null,
    temp_last_run_time = 0,
    existNoticeMsgs = {},
    notice_has_more = 0;
// 发送消息
let sendMsg = (info, events) => {
  let sdkObj = sdk.get();
  let contact = info.contact;
  let msg = {
    content: info.msg.content,
    msg_type: 2,
    send_time: info.msg.send_time,
    sender_info: info.msg.sender_info,
    show_type: info.msg.show_type,
    to_id: contact.user_id,
    to_source: contact.user_source,
    at_info:info.msg.at_info || ''
  };
  let finalMsg = config.get('msg-send-converter')(msg);
  let options = {
    msg: finalMsg,
    onSendMsgBegin: events.begin,
    onSendMsgSuccess: events.success,
    onSendMsgFail: events.error,
    onUploadImgBegin: events.uploadImgBegin,
    onUploadImgSuccess: events.uploadImgSuccess,
    onUploadImgFail: events.uploadImgFail
  };
  sdkObj.sendMsg(options);
};
// 获取消息列表
let getMsgs = (contact, last_msg_id, success, error) => {
  let sdkObj = sdk.get();
  let options = {
    count: 10,
    msg_id: last_msg_id,
    option: -1,
    user_id: contact.user_id,
    user_source: contact.user_source,
    is_get_from_api: true
  };
  sdkObj.getMsgRecords(options, (msgs) => {
    let newMsgs = [];
    let show_failed = [];
    msgs.forEach((msg) => {
      msg.send_status = MsgStatus.success;
      if (`${msg.sender_id}` === `${sdkObj.me().user_id}` && `${msg.sender_source}` === `${sdkObj.me().user_source}`) {
        msg.ismine = true;
      } else {
        msg.ismine = false;
      }
      newMsgs.unshift(msg);
      if (!isEmpty(SupportedMsgs)) {
        var show_type = msg.show_type ? msg.show_type : msg.content && msg.content.type ? msg.content.type : null;
        if(!isEmpty(show_type) && isEmpty(SupportedMsgs[show_type])){
          show_failed.push(msg);
        }
      }
    });
    success(newMsgs);
    if (show_failed.length) {
      sdk.get().reportMessages({
        show_failed: show_failed
      });
    }
  }, error);
};

// 获取提醒服务消息
let getNoticeMsgs = (last_notice_id, last_run_time, success, error) => {
  let sdkObj = sdk.get();
  let options = {
    last_notice_id: last_notice_id,
    last_run_time: last_run_time,
    count: 20
  };
  sdkObj.getNoticeTaskBatch(options, (data) => {
    temp_last_notice_id = data.last_notice_id;
    temp_last_run_time = data.last_run_time;
    notice_has_more = data.has_more;
    success(data.notice_list);
  }, error);
}

// 确认消息已阅读
let ackMsgRead = (ackMsgArray, success, error) => {
  sdk.get().ackMsgRead(ackMsgArray, success, error);
};

// 消息转换
let textConvert = (content) => {
  // xssFilter
  content = xssFilter(content);
  // 换行处理
  content = content.replace(/(\n)/g, '<br>');
  // 文本多个空格替换
  content = content.replace(/\s/g, '&nbsp;');
  // 链接转换
  content = replaceUrlSrc(content);
  // 表情转换
  let convertText = function (content) {
    if (!util.isString(content)) {
      return content;
    }
    let resultArr = [];
    let subStr = content;
    content.replace(/(\[[^[\]]*\])/g, function (item) {
      let emotionID = emotionTitles.indexOf(item.replace(/[[\]]/g, ''));
      let startIndex = subStr.indexOf(item);
      let endIndex = startIndex + item.length;
      // 表情文本
      if (emotionID !== -1) {
        if (startIndex !== 0) {
          resultArr.push({
            type: 'text',
            value: subStr.substr(0, startIndex)
          });
        }
        resultArr.push({
          type: 'emotion',
          value: emotionID + 1
        });
      } else {
        resultArr.push({
          type: 'text',
          value: subStr.substr(0, endIndex)
        });
      }
      subStr = subStr.substr(endIndex);
      return content;
    });
    if (subStr !== '') {
      resultArr.push({
        type: 'text',
        value: subStr
      })
    }
    return resultArr;
  };
  return convertText(content);
};

let xssFilter = (input) => {
  return html2Text(input);
};

// 替换url
let replaceUrlSrc = (txt) => {
  let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/ig;
  return txt.replace(reg, (item) => {
    return '<a href="' + item + '" target="_self">' + item + '</a>';
  });
};

// 设置用户默认头像
let setDefaultAvatar = (userinfo) => {
  if (_isEmpty(userinfo) || _isEmpty(userinfo.avatar)) {
    userinfo = !_isEmpty(userinfo) ? userinfo : {};
    userinfo.avatar = isAnonymousSession(userinfo) ? config.get('default-anonymous-avatar') : config.get('default_avatar');
  }
  return userinfo;
};

let _isEmpty = (input) => {
  return `${input}` === 'null' || `${input}` === 'undefined' || `${input}` === '';
};
let _showISDCaptcha = (data, callback) => {
  let level = data.param.level;
  let width = data.param.width;
  let sessionId = data.responseId;
  let captcha = window.ISDCaptcha({
    element: 'ISDCaptcha',             // 验证码组件需要绑定的元素ID
    width: width,                     // 图片宽度,需管理后台设置,不能再页面自定义，
    type: level,                       // 验证码类型; 从SCF服务register接口中组件参数返回
    showType: 'win',                   // 展现形式;win:弹出，popup:触发,'':默认为嵌入
    sessionId: sessionId,              // 从SCF服务register接口中返回
    winAutoShow: true,                 // 弹出式时添加此属性会自动弹出,默认不自动弹出
    successCallback(data) {
      let params = {
        'sessionId': sessionId,
        'level': level,
        'successToken': data.successToken
      };
      sdk.get().validateCaptcha(params, function (data) {
        callback(data);
      }, function () {
        callback(null);
      });
    },
    failCallback() {
      callback(null);
    }
  });
  captcha.init();// 初始化组件
};
let saveExistMsgs = (msg) => {
  if (`${msg.msg_id}` !== '') {
    existMsgs[msg.msg_id] = msg;
  }
};
let saveExistNoticeMsgs = (msg) => {
  if (`${msg.notice_id}` !== '') {
    existNoticeMsgs[msg.notice_id] = msg;
  }
}

const gatherExistFalseMsgs = falseNewsDic.gatherExistFalseMsgs;

let richTextConvert = (msgitem) => {
  // 富文本内容处理
  try {
    let msgcontent = msgitem.content;
    if (!msgcontent.extra) {
      return msgitem;
    }
    let richobj = JSON.parse(msgcontent.extra);
    if (!richobj || !richobj.richtext_format || !richobj.richtext_format.richtext) {
      return msgitem;
    }
    let richtext = richobj.richtext_format.richtext;
    richobj.richtext_format.richtext = xssFilter(richtext);
    // 富文本转换
    msgcontent.extra = JSON.stringify(richobj);
    return richTextFormat(msgitem);
  } catch (e) {
    return msgitem
  }
};

// 检验文件
let checkFile = (message, success, error) => {
  let fileContent = message.content;
  let fileUrl = fileContent.url;
  let checkFileParams = {
    wos_file_name: fileContent.wos_file_name,
    to_source: message.to_source,
    url: fileUrl
  };
  sdk.get().checkFile(checkFileParams, success, error)
};

// 下载文件
let downloadFile = (message, cb) => {
  let onDownloadFail = function (error) {
    message.send_status = MsgStatus.download_fail;
    if (error === '') {
      message.feedback = '您的网络未连接，请检查后重试。';
    } else {
      message.feedback = error.error_msg;
    }
    cb && cb(message);
  };
  checkFile(message, () => {
    let fileContent = message.content;
    let fileUrl = fileContent.url;
    message.send_status = MsgStatus.downloading;
    cb && cb(message);
    if (fileUrl) {
      window.$.ajax({
        type: 'GET',
        cache: false,
        url: fileUrl,
        data: '',
        success: function () {
          message.send_status = MsgStatus.download_success;
          cb && cb(message);
          fileHandler.downloadFromURL(fileUrl, fileContent.original_file_name);
        },
        error: function () {
          onDownloadFail({ error_msg: '文件失效！' });
        }
      });
    } else {
      onDownloadFail({ error_msg: '文件地址非法！' });
    }
  }, (error) => {
    onDownloadFail(error);
  });
};

// 表情对应文案
let emotionTitles = [
  '微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡觉', '大哭', '尴尬',
  '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑',
  '愉快', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '悠闲', '奋斗',
  '咒骂', '疑问', '嘘', '晕', '疯了', '衰', '骷髅', '敲打', '再见', '擦汗',
  '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了',
  '阴险', '亲亲', '惊吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡',
  '米饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹',
  '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼品', '拥抱', '强', '弱',
'握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', '不', 'OK', '小恶魔',
'大恶魔', '多喝水', '戴口罩', '医护人员', '白衣天使', '比心', '不熬夜', '祖国加油',
'国泰民安', '勤洗手', '少外出', '配合检查'
];

// 保存temp_msg_id
let _temp_msg_id = 0,   // 临时消息id
  _temp_msgs = {},   // key:temp_msg_id, value:msg
  last_show_time_stamp = 0,
  first_show_time_stamp = 0,
  existMsgs = {};       // key:msg_id, value:msg

const _replaceText = function (originalText, rules) {
  if (isEmpty(originalText) || isEmpty(rules) || rules.length === 0) {
    return originalText;
  }
  var result = originalText;
  rules.sort(function (a, b) {
    return b.rule.pos_start - a.rule.pos_start
  })
  for(let value of rules) {
    var rule = value.rule;
    var posStart = rule.pos_start;
    var posEnd = rule.pos_end;
    // var targetText = rule.name;
    var originalLen = originalText.length;
    // if (originalText.substring(posStart, posEnd) === targetText || posStart == posEnd) {
      result = result.substring(0, posStart) + value.replaceText + result.substring(posEnd, originalLen);
    // }
  }
  return result;
}

export default {
  state: {
    me: {},
    contact: {},
    onlinestatus: null,
    have_more_msg: true,
    is_show_captcha: false,
    captcha_temp_msg_id: 0, // 触发验证码的临时id
    msgs: [],
    topic: null, // 帖子信息
    is_show_editor: true, // 官方账号不显示编辑框
    last_play_video: '',
    now_wos_filename: '',
    del_msg_toast: {},
    card_ajax_toast: '',
    del_msg_toast: '',
    card_ajax_toast: '',
    notices_msgs: []
  },
  mutations: {
    [SET_ME](state, me) {
      state['me'] = me;
    },
    [SET_CONTACT](state, contact) {
      state['contact'] = contact;
    },
    [SET_ONLINE_STATUS](state, onlinestatus) {
      state['onlinestatus'] = onlinestatus;
    },
    [ADD_MSGS](state, msgs) {

      // 过滤重复的消息
      msgs = msgs.filter((msgitem) => {
        return `${msgitem.msg_id}` === '' || !existMsgs[msgitem.msg_id] || util.isEmpty(msgitem.msg_id) && msgitem.is_false_new;
      });

      if (msgs.length === 0) {
        state['have_more_msg'] = false;
        return;
      }
      // 判断消息列表是插入在头部(-1)还是尾部(1)
      let insertPos = 1;
      if (state.msgs.length > 0 && state.msgs[0].msg_id && msgs[msgs.length - 1].msg_id !== '' && strToNumCompare(msgs[msgs.length - 1].msg_id, state.msgs[0].msg_id) < 0) {
        first_show_time_stamp = state.msgs[0].send_time;
        msgs.reverse();
        insertPos = -1;
      }

      // 循环插入消息列表
      for (let i = 0; i < msgs.length; i++) {
        // 过滤自己的tips, should remove, mark by likd-a, bug/detail/weiliao-1962
        // if (`${msgs[i].show_type}` === 'tip' && `${msgs[i].sender_id}` === `${state.me.user_id}` && `${msgs[i].sender_source}` === `${state.me.user_source}`) {
        //   continue;
        // }
        // 消息临时id
        if ([MsgStatus.sending, MsgStatus.uploading].indexOf(msgs[i].send_status) !== -1) {
          msgs[i].temp_msg_id = --_temp_msg_id;
          _temp_msgs[msgs[i].temp_msg_id] = msgs[i];
        }

        let time_stamp_type = insertPos === 1 ? last_show_time_stamp : first_show_time_stamp;
        if (Math.abs(msgs[i].send_time - time_stamp_type) < 2 * 60 * 1000) {
          msgs[i].isShowTime = false;
        } else {
          if (insertPos === 1) {
            last_show_time_stamp = msgs[i].send_time;
          } else if (insertPos === -1) {
            first_show_time_stamp = msgs[i].send_time;
          }
          msgs[i].isShowTime = true;
        }

        // 默认头像设置
        let avatar = msgs[i].sender_info && msgs[i].sender_info.avatar && msgs[i].sender_info.avatar !== '';
        if (!avatar) {
          msgs[i].sender_info = msgs[i].sender_info ? msgs[i].sender_info : {};
          msgs[i].sender_info.avatar = isAnonymousSession(msgs[i].sender_info) ? config.get('default-anonymous-avatar') : config.get('default_avatar');
        }

        // 音视频及位置过滤
        let supported_show_type = ['text', 'tip', 'image', 'audio', 'card', 'minicard', 'universal_card1', 'universal_card2', 'universal_card3', 'universal_card4', 'universal_card5', 'private_card_ganji', 'mix', 'video', 'file', 'modify_msg', 'shop_common_card', 'wechat_notice_card'];
        if (config.get('is_support_provide_contactinfo')) {
          supported_show_type = supported_show_type.concat(['default_contactinfo_card', 'provide_contactinfo_card']);
        }
        if (supported_show_type.indexOf(msgs[i].show_type) == -1) {
          // 将音频和视频邀请转换为文案
          if (msgs[i].show_type === 'call_audio') {
            msgs[i].content.msg = '[收到一条语音聊天消息，请在客户端查看]';
          } else if (msgs[i].show_type === 'call_video') {
            msgs[i].content.msg = '[收到一条视频聊天消息，请在客户端查看]';
          } else if (msgs[i].show_type !== 'false_msg'){
            msgs[i].content = {}
            msgs[i].content.msg = '[消息格式暂不支持，请在客户端查看]';
          }
          if (msgs[i].show_type === 'false_msg') {

          } else {
            msgs[i].show_type = 'text';
            msgs[i].content.type = 'text';
          }
        }
        // 消息体转换
        if (msgs[i].show_type === 'text') {
          // 如果为普通消息，则对消息内容格式处理
          if (!msgs[i].ismine && msgs[i].at_info && !isGroupUser({ user_source: msgs[i].to_source })) {
            var atInfo;
            var rules = [];
            if (typeof (msgs[i].at_info) === 'string') {
              atInfo = jsonHandler.parse(msgs[i].at_info);
            }
            var targetsArr = atInfo.targets;
            //let me = gdic.get('me');
            if (!(isEmpty(targetsArr) || targetsArr.length == 0)) {
              for (let item of targetsArr) {
                let txt;
                //if (meKey === item.id + '@' + item.source && me.userInfo) {
                  txt = '@' + state.me.user_name;
                //}
                if (!isEmpty(txt)) {
                  rules.push({
                    rule: item,
                    replaceText: txt
                  })
                }
              }
            }
            msgs[i].content.msg = _replaceText(msgs[i].content.msg, rules);
          }
          if (!isNeedConvert(msgs[i].content)) {
            msgs[i].content.msg = textConvert(msgs[i].content.msg);
          } else {
            msgs[i] = richTextConvert(msgs[i]);
          }
        } else if (msgs[i].show_type === 'audio') {
          if (msgs[i].isPlaying === undefined) {
            msgs[i].isPlaying = false;
          }
        } else if (msgs[i].show_type === 'tip') {
          // tip含链接富文本处理
          msgs[i] = richTextConvert(msgs[i]);
        } else if (msgs[i].show_type == 'wechat_notice_card') {
          let msgs_preview = [];
          msgs[i].content.msgs_preview.forEach(item => {
            item.content = typeof item.content == 'string' ? JSON.parse(item.content) : item.content;
            msgs_preview.push(item);
          });
          msgs[i].msgs_preview = msgs_preview.length > 0 ? msgs_preview[0].content : '';
          if (msgs[i].msgs_preview.type === 'audio') {
            msgs[i].isPlaying = false;
            let oldUrl = msgs[i].msgs_preview.url;
            msgs[i].msgs_preview.url = config.get('audio-converter')(oldUrl);
            msgs[i].msgs_preview.oldUrl = oldUrl;
            console.log(msgs[i]);
          }
          // 提醒卡片中不支持的消息类型
          if (supported_show_type.indexOf(msgs[i].msgs_preview.type) == -1) {
            if (msgs[i].show_type !== 'false_msg'){
              msgs[i].msgs_preview.msg = '[消息格式暂不支持，请在客户端查看]';
              msgs[i].msgs_preview.type = 'text';
            }
          }

          if (!isNeedConvert(msgs[i].msgs_preview)) {
            msgs[i].msgs_preview.msg = textConvert(msgs[i].msgs_preview.msg);
          } else {
            msgs[i] = richTextConvert(msgs[i]);
          }

          console.log('wechat_notice_card:', msgs[i])
        }

        if (insertPos === -1 && msgs[i].msg_id !== '') {
          state.msgs.unshift(msgs[i]);
        } else {
          state.msgs.push(msgs[i]);
        }

        // 将已经完成的消息进行存储
        if (!msgs[i].is_false_new) {
          saveExistMsgs(msgs[i]);
        } else {

        }
      }
    },
    [UPDATE_MSG](state, msg) {
      let oldStateMsgs = state.msgs;
      for (let j = 0; j < oldStateMsgs.length; j++) {
        if (!util.isEmpty(msg.msg_id) && !util.isEmpty(oldStateMsgs[j].msg_id) && strToNumCompare(oldStateMsgs[j].msg_id.toString(), msg.msg_id.toString()) === 0) {
          // 由于阅读的状态和播放状态是由不同的action触发，对于已经确认已读的消息，修改播放状态时保持已读的状态
          if (oldStateMsgs[j].play_time !== 0 && msg.play_time === 0) {
            msg.play_time = oldStateMsgs[j].play_time;
          }
          state.msgs.splice(j, 1, msg);
          saveExistMsgs(msg);
          break;
        } else if (!util.isEmpty(msg.temp_msg_id) && !util.isEmpty(oldStateMsgs[j].temp_msg_id) && strToNumCompare(oldStateMsgs[j].temp_msg_id.toString(), msg.temp_msg_id.toString()) === 0) {
          state.msgs.splice(j, 1, msg);
          // 将已经完成的消息进行存储
          saveExistMsgs(msg);
          break;
        } else if (!util.isEmpty(msg.temp_msg_id) && !util.isEmpty(oldStateMsgs[j].temp_msg_id) && `${msg.temp_msg_id}` === `${oldStateMsgs[j].temp_msg_id}`) {
          state.msgs.splice(j, 1, msg);
          break;
        }
      }
    },
    [RESET_MSGS](state, msgs) {
      state.msgs.splice(0, state.msgs.length);
      msgs.forEach((msg) => {
        state.msgs.push(msg);
      });
    },
    [SET_HAVE_MORE_MSG](state, value) {
      state['have_more_msg'] = value;
    },
    [SET_IS_SHOW_CAPTCHA](state, value) {
      state['is_show_captcha'] = value;
    },
    [SET_CAPTCHA_TEMP_MSG_ID](state, value) {
      state['captcha_temp_msg_id'] = value;
    },
    // 更新帖子
    [SET_TOPIC](state, topic) {
      state['topic'] = topic;
    },
    [SET_IS_SHOW_EDITOR](state, value) {
      state['is_show_editor'] = value;
    },
    [UPDATE_NOW_VIDEO](state, value) {
      state['last_play_video'] = value;
    },
    [UPDATE_WOS_FILENAME](state, value) {
      state['now_wos_filename'] = value;
    },
    [DEL_MSGS](state, msgs) {
      let delMsgIds = [];
      msgs.map((item) => {
        delMsgIds.push(item.msg_id);
      })
      if (delMsgIds.length === 0) {
        return;
      }
      let oldMsgArr = state.msgs;
      let preShowTimeStamp;
      state.msgs = oldMsgArr.filter((msgitem) => {
        if (msgitem.isShowTime && strToNumCompare(msgitem.msg_id, delMsgIds[0]) < 0) {
          preShowTimeStamp = msgitem.send_time;
        }
        return delMsgIds.indexOf(msgitem.msg_id) === -1;
      }).map((msgitem) => {
        // 更新删除之后的消息的时间戳展示
        if (strToNumCompare(msgitem.msg_id, delMsgIds[0]) > 0) {
          let delta = Math.abs(msgitem.send_time - preShowTimeStamp);
          msgitem.isShowTime = delta > 2 * 60 * 1000;
          if (msgitem.isShowTime) {
            preShowTimeStamp = msgitem.send_time;
          }
        }
        return msgitem;
      });
    },
    [DEL_MSG_TOAST](state, obj) {
      state.del_msg_toast = obj;
    },
    [CARD_AJAX_TOAST](state, txt) {
      state.card_ajax_toast = txt;
    },
    [ADD_NOTICE_MSGS](state, notices_msgs) {
      state.notices_msgs = [];
      for (let i = 0; i < notices_msgs.length; i++) {
        if(notices_msgs[i].msgs && notices_msgs[i].msgs.length > 0) {
          notices_msgs[i].msgs[0].content = notices_msgs[i].msgs[0].content ? JSON.parse(notices_msgs[i].msgs[0].content) : notices_msgs[i].msgs[0].content;
        }
        if (notices_msgs[i].run_time > parseInt(new Date().getTime()/1000)) {
          state.notices_msgs.push(notices_msgs[i]);
        }
      }
      // 根据提醒时间排序
      let compare = function(arg) {
        return function(a, b) {
          return a[arg] - b[arg];
        }
      }
      state.notices_msgs = state.notices_msgs.sort(compare('run_time'));
    }
  },
  actions: {
    send(context, info) {
      let msgObj = {};
      extend(true, msgObj, info.msg, {
        send_status: MsgStatus.sending
      });
      info.contact = { ...context.state.contact };
      // 获取自己的信息
      let meInfo = { ...context.state.me };
      info.msg.sender_info = msgObj.sender_info = meInfo;

      // 调起消息发送接口
      console.log('info', info);
      sendMsg(info, {
        begin() {
          if (msgObj.content.type === 'image' || (msgObj.content.type === 'file' && !msgObj.is_resend) || msgObj.content.type === 'video') {
            return;
          }
          context.commit('ADD_MSGS', [msgObj]);
        },
        success(data) {
          delete _temp_msgs[msgObj.temp_msg_id];
          let msg2update = {
            ...msgObj,
            send_status: MsgStatus.success,
            msg_id: data.msg_id,
            send_time: data.send_time,
            sender_id: info.msg.sender_info.user_id,
            sender_source: info.msg.sender_info.user_source,
            sender_info: info.msg.sender_info,
            show_type: info.msg.show_type,
            to_id: info.contact.user_id,
            to_source: info.contact.user_source
          };
          context.commit('UPDATE_MSG', msg2update);
        },
        error(error) {
          let feedback;
          if (error === '') {
            feedback = '您的网络未连接，请检查后重试。';
          } else if (error.error_code === 42009) {
            return config.get('bind-cellphone')();
          } else {
            // 根据配置信息判断是否显示错误信息
            if (!error.msg_hide) {
              feedback = error.error_msg;
            }
          }

          let msg2update = {
            ...msgObj, send_status: MsgStatus.fail, feedback_info: feedback
          };
          context.commit('UPDATE_MSG', msg2update);

          // 触发验证码
          if (error.error_code === 40021) {
            //埋点统计（验证码出现）
            WMDA_REPORT && WMDA_REPORT('custom',{event_id:'22'})
            let showCaptcha = () => {
              // 获取验证码信息
              sdk.get().getCaptcha({
                normal_get: 1,
                captcha_ver: 'v3',
                captcha_width: window.screen.width - 100
              }, (data) => {
                // 根据返回的数据格式，决定用信质弹窗展示还是用内部组件
                if (!_isEmpty(data.param) && !_isEmpty(data.param.level) && !_isEmpty(data.param.width)) {
                  let captcha_cb = (data) => {
                    if (!_isEmpty(data) && `${data}` === '0') {
                      context.dispatch('resend', msg2update.temp_msg_id);
                    } else {
                      showCaptcha();
                    }
                  };
                  _showISDCaptcha(data, captcha_cb);
                }
              }, () => {
                showCaptcha();
              });
            };
            showCaptcha();
          }
        },
        uploadImgBegin: function () {
          context.commit('ADD_MSGS', [msgObj]);
        },
        uploadImgSuccess: function (msg) {
        },
        uploadImgFail: function () {
          let feedback = '图片上传失败，请重试。';
          let msg2update = {
            ...msgObj, send_status: MsgStatus.fail, feedback_info: feedback
          };
          context.commit('UPDATE_MSG', msg2update);
        }
      });
    },
    resend(context, temp_msg_id) {
      // 存储之前的消息列表
      const lastMsgs = [...context.state.msgs];
      let oldMsgObj = {};
      let pos;
      // 获取需要重发的消息
      if (!isNaN(temp_msg_id)) {
        for (let k = lastMsgs.length - 1; k >= 0; k--) {
          if (strToNumCompare(lastMsgs[k].temp_msg_id, temp_msg_id) === 0) {
            pos = k;
            break;
          }
        }
        // 重新拼接消息列表
        lastMsgs.splice(pos, 1);
        context.commit('RESET_MSGS', lastMsgs);
        // 重新发送,修改发送状态
        oldMsgObj.msg = _temp_msgs[temp_msg_id];
        if (oldMsgObj.msg && oldMsgObj.msg.show_type == 'text') {
          var msgArr = oldMsgObj.msg.content.msg;
          var msgContent = '';
          msgArr.map((value, index) => {
            var msgObj = value;
            var type = msgObj.type;
            switch (type) {
              case 'text':
                msgContent += msgObj.value;
                break;
              case 'emotion':
                var emotionIndex = msgObj.value - 1;
                msgContent += `[${emotionTitles[emotionIndex]}]`;
                break;
            }
          });
          oldMsgObj.msg.content.msg = msgContent;
        }
        oldMsgObj.msg.is_resend = true;
        context.dispatch('send', oldMsgObj);
      }
    },
    getMsgs(context, contact) {
      // 调起接口返回消息列表
      getMsgs(contact, null, (msgs) => {
        if([...context.state.msgs].length !== 0){
          return
        }
        let _msgs = [];
        let tmpKey = contact.user_id + '@' + contact.user_source;
        let me = context.state.me;
        let meKey = me.user_id + '@' + me.user_source;
        for(let msg of msgs) {
          if (msg.msg_id) {
            _msgs.push(msg);
            if (!contact.shop_id) {
              _msgs = _msgs.concat(gatherExistFalseMsgs(tmpKey, msg.msg_id, meKey));
            }
          }
        }
        context.commit('ADD_MSGS', _msgs);
        // 判断是否have_more_msg
        if (msgs.length < 10 || `${msgs[msgs.length - 1].link_msg_id}` === '0') {
          context.commit('SET_HAVE_MORE_MSG', false);
        }
      }, (error) => {
        let _errorMsgs = []
        context.commit('ADD_MSGS', _errorMsgs);
        context.commit('DEL_MSG_TOAST', {text:'拉取消息记录失败',type:'warn'});
      });
    },
    receivedMsgs(context, msgs) {
      let contact = { ...context.state.contact };
      let me = sdk.get().me();
      var show_failed = [];
      let needShowMsgs = [];
      // 未读消息数置为零
      if (contact != null) {
        sdk.get().read(contact.user_id, contact.user_source);
      }
      msgs.forEach((msg) => {
        let isMine;
        if (`${me.user_id}` === `${msg.sender_id}` && `${me.user_source}` === `${msg.sender_source}`) {
          isMine = true;
        } else if (`${contact.user_id}` === `${msg.sender_id}` && `${contact.user_source}` === `${msg.sender_source}`) {
          isMine = false;
        } else {
          return;
        }
        let msglist = msg.msg_list;
        msglist.forEach((msgitem) => {
          // 对于从其他端同步过来的，不是发给当前联系人的消息，不保存
          if (isMine && (`${msgitem.to_id}` !== `${contact.user_id}` || `${msgitem.to_source}` !== `${contact.user_source}`)) {
            return true;
          }
          msgitem.send_status = MsgStatus.success;
          msgitem.ismine = isMine;
          msgitem.feedback_info = '';
          // 补全消息发送者的信息
          if (!msgitem.sender_info || !msgitem.sender_info.avatar) {
            if (!isMine) {
              msgitem.sender_info = { ...context.state.contact };
            } else {
              msgitem.sender_info = { ...context.state.me };
            }
          }
          if (!isEmpty(SupportedMsgs)) {
            var show_type = msgitem.show_type ? msgitem.show_type : msgitem.content && msgitem.content.type ? msgitem.content.type : null;
            if(!isEmpty(show_type) && isEmpty(SupportedMsgs[show_type])){
              show_failed.push(msgitem);
            }
          }
          needShowMsgs.unshift(msgitem);
        });
        needShowMsgs.sort((a, b) => {
          return strToNumCompare(a.msg_id, b.msg_id) > 0 ? 1 : strToNumCompare(a.msg_id, b.msg_id) < 0 ? -1 : 0;
        });
        context.commit('ADD_MSGS', needShowMsgs);
      });
      if (show_failed.length) {
        sdk.get().reportMessages({
          show_failed: show_failed
        });
      }
    },
    replaceMsgReceived(context, msgs) {
      let oldMsgList = [...context.state.msgs];
      msgs.forEach((msg) => {
        let msglist = msg.msg_list;
        msglist.forEach((originitem) => {
          let replace_num;
          oldMsgList.filter(function (msgitem, index) {
            if (msgitem.msg_id && originitem.replace && originitem.replace.msg_id && strToNumCompare(msgitem.msg_id, originitem.replace.msg_id) === 0) {
              replace_num = index;
              originitem.msg_id = msgitem.msg_id;
              originitem.isShowTime = msgitem.isShowTime;
              originitem.send_time = msgitem.send_time;
              return msgitem;
            }
          });
          if (!_isEmpty(replace_num)) {
            context.commit('UPDATE_MSG', originitem);
          }
        });
      });
    },
    addMoreMsgs(context) {
      // 修改滚轮的状态
      let contact = { ...context.state.contact };
      let me = context.state.me;
      let meKey = me.user_id + '@' + me.user_source;
      let msgs = [...context.state.msgs];
      let last_msg_id = null;
      let link_msg_id = null;
      if (msgs.length === 0) {
        return;
      } else if (msgs.length > 0 && msgs[0].msg_id && msgs[0].msg_id !== '') {
        last_msg_id = msgs[0].msg_id;
        link_msg_id = msgs[0].link_msg_id?msgs[0].link_msg_id:null;
      }
      // 调起接口返回消息列表
      getMsgs(contact, last_msg_id, (msgs) => {
        //保证历史拉取的数据是连续的 和网络延迟退出的异常处理
        if([...context.state.msgs].length !== 0){
          let _msgs = [];
          let tmpKey = contact.user_id + '@' + contact.user_source;
          for(let msg of msgs) {
            if (msg.msg_id) {
              _msgs.push(msg);
              if (!contact.shop_id) {
                _msgs = _msgs.concat(gatherExistFalseMsgs(tmpKey, msg.msg_id, meKey));
              }
            }
          }
          // 判断是否have_more_msg
          if (msgs.length < 10 || `${msgs[msgs.length - 1].link_msg_id}` === '0') {
            context.commit('SET_HAVE_MORE_MSG', false);
          }
          context.commit('ADD_MSGS', _msgs);
        }
        
      }, (error) => {
        let _errorMsgs = []
        context.commit('ADD_MSGS', _errorMsgs);
        context.commit('DEL_MSG_TOAST', {text:'拉取消息记录失败',type:'warn'});
      });
    },
    addFalseMsgs(context, falseMsgsObj) {
      let contact = { ...context.state.contact };
      if (!isEmpty(falseMsgsObj)) {
        let { tmpKey, falseMsgs } = falseMsgsObj;
        if (!isEmpty(contact) && contact.user_id && contact.user_source && [contact.user_id, contact.user_source].join('@') === tmpKey) {
          context.commit('ADD_MSGS', falseMsgs);
        }
      }
    },
    resetMsgs(context, msgs) {
      // 将上一个联系人的消息列表清空
      context.commit('RESET_MSGS', msgs);
    },
    resetCaptcha(context) {
      context.commit('SET_IS_SHOW_CAPTCHA', false);
    },
    leavePageReset(context) {
      context.commit('RESET_MSGS', []);
      context.commit('SET_CONTACT', {});
      context.commit('SET_HAVE_MORE_MSG', true);
      context.commit('SET_IS_SHOW_CAPTCHA', false);
      context.commit('SET_CAPTCHA_TEMP_MSG_ID', 0);
      context.commit('SET_TOPIC', null);
      last_show_time_stamp = 0;
      first_show_time_stamp = 0;
      existMsgs = {};
      temp_last_run_time = 0;
      temp_last_notice_id = null;
    },
    updateAudioPlayStatus(context, audioObj) {
      context.commit('UPDATE_MSG', audioObj);
    },
    ackMsgRead(context, audioObj) {
      let ackMsgArray = [];
      let newAudioObj = { ...audioObj };
      let ackMsgObj = {
        sender_id: newAudioObj.sender_id,
        sender_source: newAudioObj.sender_source,
        msg_id: newAudioObj.msg_id,
        to_id: newAudioObj.to_id,
        to_source: newAudioObj.to_source
      };
      ackMsgArray.push(ackMsgObj);
      ackMsgRead(ackMsgArray, () => {
        context.commit('UPDATE_MSG', { ...newAudioObj, play_time: (new Date()).getTime() });
      });
    },
    setMe(context, me) {
      sdk.get().getContact(me.user_id, me.user_source, (userinfo) => {
        userinfo = setDefaultAvatar(userinfo);
        context.commit('SET_ME', userinfo);
      });
    },
    setContact(context, contact) {
      contact = setDefaultAvatar(contact);
      context.commit('SET_CONTACT', contact);
    },
    updateOnlineStatus(context, data) {
      let contact = context.state.contact;
      if (!contact || !contact.user_id || !contact.user_source) {
        return;
      }

      if (`${contact.user_id}@${contact.user_source}` !== `${data.user_id}@${data.user_source}`) {
        return;
      }

      context.commit('SET_ONLINE_STATUS', data.is_online);
    },
    // 更新帖子
    setTopic(context, topic) {
      context.commit('SET_TOPIC', topic);
    },
    // 是否禁用消息发送框
    setIsShowEditor(context, isShow) {
      context.commit('SET_IS_SHOW_EDITOR', isShow);
    },
    downloadFile(context, message) {
      let msg = {};
      extend(true, msg, message);
      downloadFile(msg, (msg2update) => {
        context.commit('UPDATE_MSG', msg2update);
      })
    },
    recordLastVideo(context, message) {
      context.commit('UPDATE_NOW_VIDEO', message)
    },
    saveWosFileName(context, message) {
      context.commit('UPDATE_WOS_FILENAME', message)
    },
    delMsgs(context, msgs) {
      let msgsList = extend(true, [], msgs);
      msgsList.map((msg) => {
        let options = {
          sender_id: msg.sender_id,
          sender_source: msg.sender_source,
          msg_id: msg.msg_id,
          to_id: msg.to_id,
          to_source: msg.to_source
        };
        sdk.get().delMsg(options, () => {
          context.commit('DEL_MSGS', msgs);
          context.commit('DEL_MSG_TOAST', {text:'删除成功',type:'success'});
        }, () => {
          context.commit('DEL_MSG_TOAST', {text:'删除失败',type:'warn'});
        })
      })
    },
    cardAjax(context, card) {
      context.commit('CARD_AJAX_TOAST', '');
      let is_shop_model = isShopModeUser(context.state.contact);
      var actionPostData = card.actionPostData;
      if (typeof actionPostData == 'string') {
        try {
          actionPostData = jsonHandler.parse(actionPostData);
        } catch (e) {
          actionPostData = {};
        }
      }
      actionPostData = {...actionPostData};
      sdk.get().cardAjax(card.actionData, {
        shop_id: is_shop_model ? (isShopModeUserSource(card.msg.sender_source) ? card.msg.sender_id : card.msg.to_id) : null,
        shop_source: is_shop_model ? (isShopModeUserSource(card.msg.sender_source) ? card.msg.sender_source : card.msg.to_source) : null,
      }, actionPostData, function (data, msg) {
        if (!isEmpty(msg)) {
          context.commit('CARD_AJAX_TOAST', msg);
        }
      }, function (res, status) {
        if (!isEmpty(res) && !isEmpty(res.msg)) {
          context.commit('CARD_AJAX_TOAST', res.msg);
        } else if (!isEmpty(status) && status == "error") {
          context.commit('CARD_AJAX_TOAST', '网络已断开，请稍后再试');
        }
      });
    },
    getNoticeMsgs (context) {
      getNoticeMsgs(null, null, (msgs) => {
        let _notices = [];
        for(let msg of msgs) {
          if (msg.notice_id) {
            _notices.push(msg);
          }
        }

        context.commit('ADD_NOTICE_MSGS', _notices);
      }, (error) => {
        console.log(error);
      });
    }
  }
};
